import { ComponentType } from 'react'
import { Navigate } from 'react-router-dom'

import { CandidatesReport } from '../grants/Reports/candidates/CandidatesReport'
import { ImpactReport } from '../grants/Reports/impact/ImpactReport'
import { TasksReport } from '../grants/Reports/tasks/TasksReport'
import { EmployeeDonationsReport } from '../workplaceGiving/Reports/employee-donations/EmployeeDonationsReport'

import { ReportFlagGate } from './ReportFlagGate'
import { getReportBySlug, ReportCard, ReportModule, reportsBasePath } from './reportsConfig'
import { useRequiredParams } from '@percent/partner-dashboard/common/hooks'

type ReportDetailContainerProps = {
  module: ReportModule
}

// Maps a report slug to its component. Each report owns its own `Insights.Domain`
// (service, colour map, locked filters) and composition, so this container only
// resolves the slug and renders the match.
const REPORT_COMPONENTS: Record<string, ComponentType<{ report: ReportCard }>> = {
  'employee-donations': EmployeeDonationsReport,
  candidates: CandidatesReport,
  tasks: TasksReport,
  impact: ImpactReport
}

// Resolves the report from the URL slug and renders its component; an unknown (or
// unregistered) slug redirects back to the module's reports list.
export function ReportDetailContainer({ module }: Readonly<ReportDetailContainerProps>) {
  const { slug } = useRequiredParams<{ slug: string }>()
  const report = getReportBySlug(module, slug)
  const ReportComponent = report && REPORT_COMPONENTS[report.slug]

  if (!report || !ReportComponent) {
    return <Navigate replace to={reportsBasePath(module)} />
  }

  return (
    <ReportFlagGate report={report} fallback={<Navigate replace to={reportsBasePath(module)} />}>
      <ReportComponent report={report} />
    </ReportFlagGate>
  )
}
